export default __webpack_public_path__ + "static/media/laundry1-beforeA-1920w.7c3a6e97.webp";